import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { resolveAssetUrl } from '@speeki/frontend-utils';
import { Typography } from '@speeki/global-ui-components';
import { IconManager } from '@speeki/icons';

import NicoleWelcome from '@assets/images/nicole_welcome.png';

import { useResponsive } from '@utils/hooks/useResponsive';

import WelcomePattern from '@shared/svgs/WelcomePattern.svg';

import {
    BoldText,
    NicoleImageWrapper,
    PatternWrapper,
    PointsList,
    PointWrapper,
    TickWrapper,
    WelcomeSectionHeader,
    WelcomeSectionWrapper,
    WelcomeTitle,
} from './WelcomeSection.styled';

const SINGLE_LINE_TITLE_HEIGHT = 52;

export const WelcomeSection = () => {
    const ref = useRef<HTMLParagraphElement>(null);
    const [isMultiLine, setIsMultiLine] = useState(false);

    const { t } = useTranslation();
    const isLg = useResponsive('lg');

    const checkLines = () => {
        const titleHeight = ref.current?.offsetHeight;
        setIsMultiLine(
            !!(titleHeight && titleHeight > SINGLE_LINE_TITLE_HEIGHT),
        );
    };

    useEffect(() => {
        checkLines();

        window.addEventListener('resize', checkLines);

        return () => {
            window.removeEventListener('resize', checkLines);
        };
    }, []);

    return (
        <WelcomeSectionWrapper>
            <WelcomeSectionHeader isMultiLine={isMultiLine}>
                <div ref={ref}>
                    <WelcomeTitle>{t('IM_NICOLE')}</WelcomeTitle>
                </div>
                <NicoleImageWrapper>
                    <img
                        alt="nicole"
                        src={resolveAssetUrl(NicoleWelcome as string)}
                    />
                </NicoleImageWrapper>
            </WelcomeSectionHeader>
            <Typography.TextBody_16_24>
                {t('WELCOME_TO_SPEEKI_PLATFORM')}
            </Typography.TextBody_16_24>
            <PointsList>
                <Typography.TextBody_16_24>
                    {t('YOU_ARE_HERE_BECAUSE')}:
                </Typography.TextBody_16_24>
                <PointWrapper>
                    <TickWrapper>
                        <IconManager icon="SvgTickSecondary" size={12} />
                    </TickWrapper>
                    <Typography.TextBody_16_24>
                        {t('YOU_ARE')}{' '}
                        <BoldText>{t('WELCOME_TEXT_1')}</BoldText>, {t('OR')}
                    </Typography.TextBody_16_24>
                </PointWrapper>
                <PointWrapper>
                    <TickWrapper>
                        <IconManager icon="SvgTickSecondary" size={12} />
                    </TickWrapper>
                    <Typography.TextBody_16_24>
                        {t('YOU_ARE')}{' '}
                        <BoldText>{t('WELCOME_TEXT_2')}</BoldText>
                    </Typography.TextBody_16_24>
                </PointWrapper>
            </PointsList>
            <Typography.TextBody_16_24>
                {t('WELCOME_TEXT_3')}
            </Typography.TextBody_16_24>
            {!isLg && (
                <PatternWrapper>
                    <img
                        alt="welcome"
                        src={resolveAssetUrl(WelcomePattern as string)}
                    />
                </PatternWrapper>
            )}
        </WelcomeSectionWrapper>
    );
};
